const FEATURE = 'incitation_newsletter';

/**
 * @param {object} data
 * @return {{}|{feature: string, click: string}}
 */
export const incitationNewsletter = (data) => {
  const hitData = { feature: FEATURE };

  switch (data.action) {
    case 'ignore':
      return {
        ...hitData,
        click: 'j_ignore',
      };
    case 'inscription':
      return {
        ...hitData,
        click: 'je_m_inscris',
      };
    default:
      return {};
  }
};
